import { render, staticRenderFns } from "./deleteTratamentButton.vue?vue&type=template&id=05320586"
import script from "./deleteTratamentButton.vue?vue&type=script&lang=js"
export * from "./deleteTratamentButton.vue?vue&type=script&lang=js"
import style0 from "./deleteTratamentButton.vue?vue&type=style&index=0&id=05320586&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports